import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { NAV_LINKS } from "@/content/sections";
import { EASE } from "@/lib/motion";

export const Navbar = ({ onQuote, onCarrier, onNavigate }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const link = NAV_LINKS.find((l) => l.href === href);
    if (link?.action === "carrier") { onCarrier?.(); return; }
    onNavigate?.(href);
  };

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: EASE }}
      className={`fixed top-0 z-50 w-full transition-colors duration-500 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto flex max-w-[1500px] items-center justify-between px-6 py-4 lg:px-12">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} data-testid="nav-logo-btn">
          <Logo />
        </button>

        <nav className="hidden items-center gap-9 lg:flex">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="link-underline font-mono text-xs uppercase tracking-[0.2em] text-zinc-300 hover:text-white"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={onQuote}
            data-testid="nav-quote-btn"
            className="hidden bg-neon px-5 py-2.5 font-mono text-xs font-semibold uppercase tracking-[0.15em] text-black transition-colors duration-300 hover:bg-white sm:block"
          >
            Get a Quote
          </button>
          <button
            className="lg:hidden text-white"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
          >
            <div className="space-y-1.5">
              <span className="block h-0.5 w-6 bg-white" />
              <span className="block h-0.5 w-6 bg-white" />
              <span className="block h-0.5 w-4 bg-neon" />
            </div>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-black/95 px-6 py-6 lg:hidden" data-testid="mobile-menu">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className="block w-full py-3 text-left font-mono text-sm uppercase tracking-[0.2em] text-zinc-300"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => { setOpen(false); onQuote(); }}
            className="mt-3 w-full bg-neon py-3 font-mono text-xs font-semibold uppercase tracking-[0.15em] text-black"
          >
            Get a Quote
          </button>
        </div>
      )}
    </motion.header>
  );
};
